<template>
<div class="item" :id="'tab-' + media">
    <div class="item-container">
        <!-- PANEL 1 -->
        <div class="item-panel" v-if="!country.code">
            <div class="col-xs-12 title" v-if="graph1.hasData == 'yes' && period != 'day'">
                {{getPeriod}} <u>{{filter}}</u> Evolution
            </div>

            <div class="col-xs-12 graph-container fixed-graph" v-if="graph1.hasData == 'yes' && period != 'day'">
                <chart :raw-data="graph1.data" :events="events" :song="song" :media="media" :chart-id="media + '-canvas'" :filter="filter" :period="period" :fill="false"></chart>
            </div>

            <div v-if="graph1.hasData == 'no' || period == 'day'" class="panel-text"><p><i class="iconify icon:iwwa:chart-style1" data-height="64"></i><br>Not enough data<br>to generate the chart.</p></div>
            <loader v-if="graph1.hasData == 'pending'" color="ripple" size="150px" style="height: 280px;"></loader>
        </div>

        <div class="item-panel" v-else>
            <div class="panel-text">
                <p><i class="iconify icon:iwwa:chart-style1" data-height="64"></i><br>No data available for <b>{{country.name}}</b><br>to generate the chart.</p>
            </div>
        </div>

        <!-- PANEL 2 -->
        <div class="item-panel" v-if="!country.code">
            <div v-if="graph2.hasData == 'yes'" class="panel-spotfify-playlists">
                <h5>{{ graph2.data.length == 100 ? "TOP "+ graph2.data.length : graph2.data.length }} Playlists</h5>
                <h6>{{ views[media].total.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") }} followers</h6>

                <div class="playlists">
                    <div class="playlist" v-for="(p, i) in graph2.data">
                        <div class="name" :title="p.name">{{ p.name }}</div>
                        <div class="followers">{{ p.followers_count.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") }}</div>
                    </div>
                </div>
            </div>

            <div v-if="graph2.hasData == 'no'" class="panel-text"><p><i class="iconify icon:iwwa:chart-style1" data-height="64"></i><br>Not enough data<br>to generate the playlists.</p></div>
            <loader v-if="graph2.hasData == 'pending'" color="ripple" size="150px" style="height: 280px;"></loader>
        </div>

        <div class="item-panel" v-else>
            <div class="panel-text">
                <p><i class="iconify icon:iwwa:chart-style1" data-height="64"></i><br>No data available for <b>{{country.name}}</b><br>for Spotify Playlists</p>
            </div>
        </div>
    </div>



    <div class="paginator text-center">
        <span v-show="graphPage != 0"><i class="iconify icon:ic:round-brightness-1"></i></span>
        <span v-show="graphPage == 0"><i class="iconify icon:ic:round-brightness-1 active"></i></span>

        <span v-show="graphPage != 1"><i class="iconify icon:ic:round-brightness-1"></i></span>
        <span v-show="graphPage == 1"><i class="iconify icon:ic:round-brightness-1 active"></i></span>
    </div>    
</div>
</template>

<script>
export default {
    props: ['song', 'media', 'views', 'period', 'filter', 'events',  'selected', 'country'],

    components: {
        'chart': require('@/components/Song/Show/Tab/Statistics/Charts/Chart.vue').default,
        'bar-chart': require('@/components/Song/Show/Tab/Statistics/Charts/BarChart.vue').default,
        'loader': require('@/components/Loader.vue').default,
        'playlists': require('@/components/Song/Show/Tab/Statistics/Charts/ShowSpotifyData.vue').default,
    },

    data() {
        return {
            graphPage: false,
            totalFollowers: -9999,

            graph1: {
                data: null,
                rawData: {
                    datasets: [],
                    labels: []                      
                },
                hasData: 'pending',
            },

            graph2: {
                data: null,
                hasData: 'pending',
            },
        }
    },

    mounted() {
        this.graphPage = 0;

        $(`#tab-${this.media} .item-container`).on('scroll', () =>{
            var sL = $(`#tab-${this.media} .item-container`).scrollLeft();
            var sW = $(`#tab-${this.media} .item-container`).width();
            this.graphPage = Math.round(sL / sW);
        });

        this.$http.get(`https://api.soundfeedapp.com/api/song/${this.song.id}/stats/spotify-playlists/followers`).then((success) => {
            this.totalFollowers = success.data.total_followers;
            this.processData('graph1');
        });
    },

    methods: {
        getData(graph){
            if (graph == 'graph1'){            
                this.$http.get(this.dataEndpoint).then((success) => {
                    this[graph].rawData = success.data.data || success.data.results;

                    var hasLabels = typeof this[graph].rawData.labels !== 'undefined';
                    var hasDatasets = typeof this[graph].rawData.datasets !== 'undefined' && this[graph].rawData.datasets.reduce((a, b) => a + b, 0);

                    if (!hasLabels || !hasDatasets) {
                        this[graph].hasData = 'no';
                        
                        //fill stuff with empty values
                        var date = new Date();
                        this[graph].rawData = {
                            datasets: [],
                            labels: []
                        }

                        for (var i = 0; i < 366; i++) {
                            this[graph].rawData.datasets.push(null);
                            this[graph].rawData.labels.push( moment(date.addDays(i - 366)).format("YYYY-MM-DD") );   
                        }                    
                    }else{
                        this[graph].hasData = 'yes';
                    }

                    this.processData(graph);
                });
            }

            if (graph == 'graph2'){
                var res = this.song.video_providers.spotify.split("/");
                res = res[res.length - 1].split("?");
                var spotify_id = res[0];

                setTimeout(() => {
                    this.$http.get(`https://spotify-collector.soundfeedapp.com/songs/${spotify_id}/playlists`).then((success) => {
                        if (Array.isArray(success.data)){
                            this[graph].data = success.data;

                            this[graph].hasData = this[graph].data.length ? "yes" : "no";
                        }else{
                            this[graph].hasData = "no";
                        }
                    });
                }, 500);  
            }
        },

        processData(graph) {
            var N = 0;
            var datasets = [];
            var labels = [];
            var lastIndex = null;
            var currentIndex = null;
            var date = null;

            switch(this.period) {
                case 'year': N = 365; break;
                case 'months': N = 90; break;
                case 'month': N = 30; break;
                case 'week': N = 7; break;
                case 'day': N = 0; break;
            }

            for (var i = 365 - N; i < 366 ; i++) { 
                date = new Date(this[graph].rawData.labels[i]);
                switch (this.filter) {
                    case 'daily': currentIndex = this[graph].rawData.labels[i]; break; 
                    case 'weekly': currentIndex = date.getWeek(); break;
                    case 'monthly': currentIndex = date.getMonth(); break;
                }

                if (lastIndex != currentIndex){
                    lastIndex = currentIndex;
                    datasets.push(0);
                    labels.push(this[graph].rawData.labels[i]);
                }

                datasets[datasets.length - 1] += this[graph].rawData.datasets[i];
            }

            this.$parent.$emit('evolution-update', this.media, datasets, this.totalFollowers);

            // remove last week/month, because we always reffere to last full week/month of data
            // if (this.filter != 'daily'){
            //     datasets.pop();
            //     labels.pop();
            // }

            // 1 point data ?
            if (datasets.length == 1){
                datasets = [null, datasets[0], null];
                labels = [moment(labels[0]).subtract(1, 'days').format('YYYY-MM-DD'), labels[0], moment(labels[0]).subtract(-1, 'days').format('YYYY-MM-DD')];
            }            
 
            this[graph].data = {
                'datasets': datasets,
                'labels': labels
            }
        },
    },

    computed: {
        getPeriod(){
            switch (this.period){
                case 'year':   return this.overallStats ? 'All Time' : 'Last Year'; break;
                case 'months': return 'Last 3 Months'; break;
                case 'month':  return 'Last Month'; break;
                case 'week':   return 'Last Week'; break;
                case 'day':   return 'Yesterday'; break;
            }
        },
        
        dataEndpoint() {
            return App.restApi + '/api/song/' + this.song.id + '/views/chart/' + this.media;
        },              
    },

    watch: {
        graphPage(){
            var g = 'graph' + (this.graphPage + 1);
            if (this[g].hasData == 'pending'){
                this.getData(g);
            }

            if (App.allowGtag) gtag('config', 'UA-152097964-2', {
                'page_path' : `/song/statistics/${this.media}/${g}`,
                'page_location': `/song/statistics/${this.media}/${g}`,
                'page_title' : `${ this.isOwner ? 'Own' : 'Other'} Song > Statistics > Spotify Playlist > Graph ${ this.graphPage + 1 }`,
            });            
        },

        period(){
            if (this.graph1.hasData == 'yes') this.processData('graph1');
        },

        filter(){
            if (this.graph1.hasData == 'yes') this.processData('graph1');
        },
    }
}
</script>